export default {

    /**
     * Get content by id
     * @param state
     * @returns {default.campaigns|{}}
     */
    getByID: state => (id) => {
        // Return content list
        return state.content[id];
    },

    /**
     * Get content by node id
     * @param state
     * @returns {default.campaigns|{}}
     */
    getByNodeId: state => (node_id) => {
        // Return content list
        return Object.values(state.content).filter(el => el.node_id == node_id);
    },

    /**
     * Get resource preview
     * @returns {(function(*))|*}
     * @param id
     */
    getPreview: state => (id) => {
        return state ? '//' + process.env.VUE_APP_CONTENT_API_URL + `/api/content/${id}/preview` : false;
        //return state ? '//' + process.env.VUE_APP_CONTENT_API_URL + `/resource/${Math.floor(id / 1000)}/${id}-preview` : false;
    },

    /**
     * Download resource
     * @returns {(function(*))|*}
     * @param id
     */
    downloadLink: state => (id) => {
        return state ? '//' + process.env.VUE_APP_CONTENT_API_URL + `/api/content/${id}` : false;
        //return state ? '//' + process.env.VUE_APP_CONTENT_API_URL + `/resource/${Math.floor(id / 1000)}/${id}` : false;
    }

}
